import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Books from "@/pages/Books";
import Stock from "@/pages/Stock";
import Consignment from "@/pages/Consignment";
import Movements from "@/pages/Movements";
import Customers from "@/pages/Customers";
import Distributors from "@/pages/Distributors";
import Settlements from "@/pages/Settlements";
import Invoices from "@/pages/Invoices";
import Returns from "@/pages/Returns";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Docs from "@/pages/Docs";
import Importer from "@/pages/Importer";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/catalogo" element={<Books />} />
              <Route path="/almacen" element={<Stock />} />
              <Route path="/deposito" element={<Consignment />} />
              <Route path="/movimientos" element={<Movements />} />
              <Route path="/clientes" element={<Customers />} />
              <Route path="/distribuidores" element={<Distributors />} />
              <Route path="/liquidaciones" element={<Settlements />} />
              <Route path="/facturas" element={<Invoices />} />
              <Route path="/devoluciones" element={<Returns />} />
              <Route path="/informes" element={<Reports />} />
              <Route path="/importar" element={<Importer />} />
              <Route path="/documentacion" element={<Docs />} />
              <Route path="/configuracion" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
